const AuthenticationActions = require("../actions/AuthenticationActions.js");

const AuthenticationReducers = {
    [AuthenticationActions.Unauthorized](prev, action) {
        return Object.assign({}, prev, {
            AuthResponse: action.Response
        });
    },
    [AuthenticationActions.Unauthenticated](prev, action) {
        return Object.assign({}, prev, {
            AuthResponse: action.Response
        });
    }
};

module.exports = AuthenticationReducers;


// WEBPACK FOOTER //
// ./src/reducers/AuthenticationReducers.js